import { useRequiredContext } from "@lib/utils";

import { PanelStack } from "../../shared/PanelStack/PanelStack";
import { HaNContext } from "../../shell/HaNContext";
import { HaNDetailsContext } from "../../shell/regions/HaNDetailsContext";
import { WorkspaceInfoPage } from "./WorkspaceInfoPage";
import { WorkspaceOccupancyInfoPage } from "./WorkspaceOccupancyInfoPage";

export const WorkspaceDetails = () => {
  const { selection } = useRequiredContext(HaNDetailsContext);

  if (selection.kind !== "area") return null;

  return <WorkspaceDetailsContent areaId={selection.id} />;
};

// Looks the area up among all of the building's areas, so changing the filters doesn't close its details
const WorkspaceDetailsContent = ({ areaId }: { areaId: string }) => {
  const { filterData } = useRequiredContext(HaNContext);
  const area = filterData.workspaces.allData.find(a => a.id === areaId);

  if (!area) return null;

  return (
    <PanelStack initial="info">
      <PanelStack.Page pageId="info">
        <WorkspaceInfoPage area={area} />
      </PanelStack.Page>

      <PanelStack.Page pageId="occupancyInfo">
        <WorkspaceOccupancyInfoPage />
      </PanelStack.Page>
    </PanelStack>
  );
};
